import { createWizard } from '@heidi/flow/wizard';

/**
 * Authenticated desktop Dictate onboarding-lite (SCR-7069).
 *
 * Same branching as the full tour for the hotkey stretch, then tone → languages
 * → ready with no sign-in / about-you. `permissions` is gated by
 * `needsPermissions` so a precheck that already found mic + accessibility
 * granted lands the user on key-confirm (no legacy step atom).
 *
 * - key-confirm confirm → goTo('try-dictation')
 * - key-confirm reject → next() into key-selection → try-dictation
 * - try-dictation Back returns to key-confirm
 */
export const dictateOnboardingLiteWizard = createWizard({
  id: 'dictateOnboardingLite',
  steps: [
    { id: 'permissions', canGoBack: false, enabled: 'needsPermissions' },
    { id: 'key-confirm', canGoBack: false },
    { id: 'key-selection' },
    { id: 'try-dictation', backTarget: 'key-confirm' },
    { id: 'tone', canGoBack: false },
    { id: 'languages', canGoBack: false },
    { id: 'ready-to-dictate', canGoBack: false },
  ],
});

export type DictateLiteStep = (typeof dictateOnboardingLiteWizard.stepIds)[number];
